import { render, staticRenderFns } from "./SalaryList.vue?vue&type=template&id=9a7a2056"
import script from "./SalaryList.vue?vue&type=script&lang=js"
export * from "./SalaryList.vue?vue&type=script&lang=js"
import style0 from "./SalaryList.vue?vue&type=style&index=0&id=9a7a2056&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports